/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerNavBarContainerSX, headerNavBarLinkSX } from '@/components/content/Header/styles/navBar/container';
import { Container, Paper, Stack } from '@mui/material';
import { FC } from 'react';
import { NavBarLeftLinks } from './NavBarLeftLinks';
import { NavBarRightLinks } from './NavBarRightLinks';

export const HeaderNavBar: FC = () => {
	return (
		<Paper sx={headerNavBarContainerSX} elevation={0} >
			<Container>
				<Stack sx={headerNavBarLinkSX}> 
					<NavBarLeftLinks />
					<NavBarRightLinks />
				</Stack>
			</Container>
		</Paper>
	);
};
